import { render, staticRenderFns } from "./InformationModalButton.vue?vue&type=template&id=1d231282&scoped=true"
import script from "./InformationModalButton.vue?vue&type=script&lang=js"
export * from "./InformationModalButton.vue?vue&type=script&lang=js"
import style0 from "./InformationModalButton.vue?vue&type=style&index=0&id=1d231282&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d231282",
  null
  
)

export default component.exports